import i18next from "i18next";

export function translate(key: string, options?: Record<string, any>): string {
    return i18next.t(key, options);
}